export default "__VITE_ASSET__BS7wrhnp__"